import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // form
  targetId: Constants.RegisterHash,
  values: {},

  // model
  serviceModel: [],
  
  // データ更新の判別フラグ
  updated: false
}

const getters = {
	get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
}

const actions = {
	show ({commit}, targetId) {
    console.log('@targetId', targetId);
    // 新規作成の場合「Constants.RegisterHash」
    // コピーの場合「NoticeId」が引き渡される
    commit('setTargetId', targetId)

		// cover
		this.dispatch('core/showModalCover')
		
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
  },

  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {serviceParams}) {
    return new Promise((resolve, reject) => {
      // 新規登録
      if (getters.isRegister(state)) {
        ApiManager.request(
          ['service'],
          ['v1ServiceListGet'],
          [serviceParams])
          .then(res => {
            let status = Utility.parseResponse(res)

            if (status.result) {
              commit('setServiceModel', res[0].data.serviceInfo)
              commit('initRegister')
              console.log('serviceModel', state.serviceModel)
              resolve()

            } else if (status.error) {
              // エラーメッセージ表示
              reject(res)
            } else {
              // アプリケーションエラー表示
              reject(null)
            }
          })
          .catch(error => {
            // アプリケーションエラー表示
            reject(null)
          })

      // コピー
      } else {
        let adminNoticeParams = {
          adminNoticeUuid: state.targetId
        }
        ApiManager.request(
          [
            'service',
            'adminNotice'
          ],
          [
            'v1ServiceListGet',
            'v1AdminNoticeDetailGet'
          ],
          [
            serviceParams,
            adminNoticeParams
          ])
          .then(res => {
            let status = Utility.parseResponse(res)

            if (status.result) {
              commit('setServiceModel', res[0].data.serviceInfo)
              commit('initModify', res[1].data)
              console.log('serviceModel', state.serviceModel)
              console.log('values', state.values)
              resolve()

            } else if (status.error) {
              // エラーメッセージ表示
              reject(res)
            } else {
              // アプリケーションエラー表示
              reject(null)
            }
          })
          .catch(error => {
            // アプリケーションエラー表示
            reject(null)
          })
      }
    })
  },

  /**
   * データ更新判別フラグの切替
   */
  setUpdated ({commit}, flag) {
    commit('setUpdated', flag)
  },
  
  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // model
  setServiceModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'serviceModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // form mode
  initRegister (state) {
    Vue.set(state, 'values', {})
    Vue.set(state.values, 'inpTargetServiceUuid', '')
    Vue.set(state.values, 'inpTitle', null)
    Vue.set(state.values, 'inpMessage', null)
    Vue.set(state.values, 'inpSignature', null)
  },
  initModify (state, data) {
    Vue.set(state, 'values', data)
    //TODO すべての場合の処理
    const serviceUuid = data.targetService
      ? data.targetService.serviceUuid || ''
      : '';
    Vue.set(state.values, 'inpTargetServiceUuid', serviceUuid)
    Vue.set(state.values, 'inpTitle', data.title)
    Vue.set(state.values, 'inpMessage', data.message)
    Vue.set(state.values, 'inpSignature', data.signature)
  },

  // updated
  setUpdated (state, flag) {
    state.updated = flag
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
